(function () {
  if (customElements.get('ce-pagination-load-previous') !== undefined) {
    return;
  }

  class PaginationLoadPrevious extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        collection: 'ce-collection',
        button: '[data-pagination-load-previous-button]',
        iconSpinnerContainer: '[data-pagination-load-previous-icon-spinner-container]',
        iconSpinner: '[data-pagination-load-previous-icon-spinner-container] > svg',
      };

      this.elements = null;

      this.previousPosition = this.getAttribute('previous-position');
      this.url = this.getAttribute('url');

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        collection: document.querySelector(this.selectors.collection),
        button: this.querySelector(this.selectors.button),
        iconSpinnerContainer: this.querySelector(this.selectors.iconSpinnerContainer),
        iconSpinner: this.querySelector(this.selectors.iconSpinner),
      };

      this.elements.button.addEventListener('click', this.handleClickButton);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.handleClickButton);
    }

    handleClickButton() {
      if (this.elements.button.hasAttribute('aria-disabled')) {
        return;
      }

      this.elements.button.setAttribute('aria-disabled', 'true');
      this.playAnimationLoading();
      this.elements.collection.paginateLoadPrevious(this.url, this.previousPosition);
    }

    playAnimationLoading() {
      requestAnimationFrame(() => {
        this.elements.iconSpinnerContainer.style.display = 'flex';
      });

      const keyframes = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 2000 * 6 : 2000,
        iterations: Infinity,
        fill: 'both',
      };

      this.elements.iconSpinner.animate(keyframes, options);
    }
  }

  customElements.define('ce-pagination-load-previous', PaginationLoadPrevious);
})();
